class TestimonialsCarousel extends HTMLElement {
  constructor() {
    super();
    this.track = this.querySelector('[data-testimonials-track]');
    this.slides = this.track ? Array.from(this.track.children) : [];
    this.index = 0;
    this.timer = null;
  }

  connectedCallback() {
    if (this.slides.length <= 1) return;

    const prev = this.querySelector('[data-testimonials-prev]');
    const next = this.querySelector('[data-testimonials-next]');
    if (prev) prev.addEventListener('click', () => this.move(-1, true));
    if (next) next.addEventListener('click', () => this.move(1, true));

    this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.addEventListener('resize', () => this.update());
    this.update();

    if (this.dataset.autoplay === 'true' && !this.reduceMotion) {
      this.interval = parseInt(this.dataset.interval, 10) || 6000;
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());
      this.start();
    }
  }

  disconnectedCallback() {
    this.stop();
  }

  perView() {
    const w = window.innerWidth;
    if (w <= 749) return 1;
    if (w <= 989) return 2;
    return 3;
  }

  maxIndex() {
    return Math.max(0, this.slides.length - this.perView());
  }

  move(dir, userInitiated) {
    const max = this.maxIndex();
    this.index += dir;
    if (this.index > max) this.index = 0;
    if (this.index < 0) this.index = max;
    this.update();
    if (userInitiated) this.start();
  }

  update() {
    const max = this.maxIndex();
    if (this.index > max) this.index = max;
    const slideWidth = this.slides[0] ? this.slides[0].getBoundingClientRect().width : 0;
    this.track.style.transform = `translateX(${-this.index * slideWidth}px)`;
  }

  start() {
    this.stop();
    if (this.dataset.autoplay !== 'true' || this.reduceMotion) return;
    this.timer = window.setInterval(() => this.move(1, false), this.interval);
  }

  stop() {
    if (this.timer) {
      window.clearInterval(this.timer);
      this.timer = null;
    }
  }
}

customElements.define('testimonials-carousel', TestimonialsCarousel);
